export const smashData = [
  // SMASH OFFERS
  {
    id: 200,
    category: "smashOffer",
    name: "Акција - 2x Classic Idzuo Smash + мали помфрит",
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
    grams: "",
    price: "1100",
    image: "https://idzuo.com/menuImages/offers/offer-smash-01.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 201,
    category: "smashOffer",
    name: "Акција - 5x Original Smash Burger + Велики помфрит",
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, 2x чедар сир, бургер сос, микс 9 салата, црвени лук, кисели краставац",
    grams: "",
    price: "2750",
    image: "https://idzuo.com/menuImages/offers/offer-smash-02.webp",
    cart: "Додајте у корпу",
  },

  //CLASSIC
  {
    id: 100,
    category: "burger",
    type: "classic",
    name: "Classic Idzuo Smash",
    variantLabel: "Classic",
    isBaseVariant: true,
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
    grams: "",
    price: "550",
    image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 101,
    category: "burger",
    type: "classic",
    name: "Classic Triple Smash",
    variantLabel: "Triple",
    isBaseVariant: false,
    subtitle: "",
    desc: "3x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
    grams: "",
    price: "620",
    image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 102,
    category: "burger",
    type: "classic",
    name: "Classic Double - Double Smash",
    variantLabel: "Double - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "4x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
    grams: "",
    price: "690",
    image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 103,
    category: "burger",
    type: "classic",
    name: "Classic Triple - Double Smash",
    variantLabel: "Triple - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "5x 70г 100% јунеће месо, 5x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
    grams: "",
    price: "770",
    image: "https://idzuo.com/menuImages/smash/smash-classic.webp",
    cart: "Додајте у корпу",
  },

  //ORIGINAL
  {
    id: 110,
    category: "burger",
    type: "original",
    name: "Original Idzuo Smash",
    variantLabel: "Classic",
    isBaseVariant: true,
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, 2x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
    grams: "",
    price: "550",
    image: "https://idzuo.com/menuImages/smash/smash-original.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 111,
    category: "burger",
    type: "original",
    name: "Original Triple Smash",
    variantLabel: "Triple",
    isBaseVariant: false,
    subtitle: "",
    desc: "3x 70г 100% јунеће месо, 2x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
    grams: "",
    price: "620",
    image: "https://idzuo.com/menuImages/smash/smash-original.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 112,
    category: "burger",
    type: "original",
    name: "Original Double - Double Smash",
    variantLabel: "Double - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "4x 70г 100% јунеће месо, 2x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
    grams: "",
    price: "690",
    image: "https://idzuo.com/menuImages/smash/smash-original.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 113,
    category: "burger",
    type: "original",
    name: "Original Triple - Double Smash",
    variantLabel: "Triple - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "5x 70г 100% јунеће месо, 5x чедар сир, бургер сос, миx 9 салата, црвени лук, кисели краставац",
    grams: "",
    price: "770",
    image: "https://idzuo.com/menuImages/smash/smash-original.webp",
    cart: "Додајте у корпу",
  },

  //JALAPENO
  {
    id: 120,
    category: "burger",
    type: "jalapeno",
    name: "Bbq Jalapeño Smash",
    variantLabel: "Classic",
    isBaseVariant: true,
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, 2x чедар сир, bbq сос, онион рингс, јапалењо паприка",
    grams: "",
    price: "550",
    image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 121,
    category: "burger",
    type: "jalapeno",
    name: "Bbq Jalapeño Triple Smash",
    variantLabel: "Triple",
    isBaseVariant: false,
    subtitle: "",
    desc: "3x 70г 100% јунеће месо, 2x чедар сир, bbq сос, онион рингс, јапалењо паприка",
    grams: "",
    price: "620",
    image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 122,
    category: "burger",
    type: "jalapeno",
    name: "Bbq Jalapeño Double - Double Smash",
    variantLabel: "Double - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "4x 70г 100% јунеће месо, 2x чедар сир, bbq сос, онион рингс, јапалењо паприка",
    grams: "",
    price: "690",
    image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 123,
    category: "burger",
    type: "jalapeno",
    name: "Bbq Jalapeño Triple - Double Smash",
    variantLabel: "Triple - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "5x 70г 100% јунеће месо, 5x чедар сир, bbq сос, онион рингс, јапалењо паприка",
    grams: "",
    price: "770",
    image: "https://idzuo.com/menuImages/smash/smash-jalapeno.webp",
    cart: "Додајте у корпу",
  },

  //BLUE CHEESE
  {
    id: 130,
    category: "burger",
    type: "bluecheese",
    name: "Blue Cheese and Bacon Smash",
    variantLabel: "Classic",
    isBaseVariant: true,
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
    grams: "",
    price: "550",
    image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 131,
    category: "burger",
    type: "bluecheese",
    name: "Blue Cheese and Bacon Triple Smash",
    variantLabel: "Triple",
    isBaseVariant: false,
    subtitle: "",
    desc: "3x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
    grams: "",
    price: "620",
    image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 132,
    category: "burger",
    type: "bluecheese",
    name: "Blue Cheese and Bacon Double - Double Smash",
    variantLabel: "Double - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "4x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
    grams: "",
    price: "690",
    image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 133,
    category: "burger",
    type: "bluecheese",
    name: "Blue Cheese and Bacon Triple - Double Smash",
    variantLabel: "Triple - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "5x 70г 100% јунеће месо, bbq сос, чедар сир, горгонзола, хрскави лук, панчета",
    grams: "",
    price: "770",
    image: "https://idzuo.com/menuImages/smash/smash-blue-cheese.webp",
    cart: "Додајте у корпу",
  },

  //ONION JAM
  {
    id: 140,
    category: "burger",
    type: "onionjam",
    name: "Onion Jam Smash",
    variantLabel: "Classic",
    isBaseVariant: true,
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
    grams: "",
    price: "550",
    image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 141,
    category: "burger",
    type: "onionjam",
    name: "Onion Jam Triple Smash",
    variantLabel: "Triple",
    isBaseVariant: false,
    subtitle: "",
    desc: "3x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
    grams: "",
    price: "620",
    image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 142,
    category: "burger",
    type: "onionjam",
    name: "Onion Jam Double - Double Smash",
    variantLabel: "Double - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "4x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
    grams: "",
    price: "690",
    image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 143,
    category: "burger",
    type: "onionjam",
    name: "Onion Jam Triple - Double Smash",
    variantLabel: "Triple - Double",
    isBaseVariant: false,
    subtitle: "",
    desc: "5x 70г 100% јунеће месо, 2× чедар сир, бургер сос, кисели краставац, џем од лука и панчете",
    grams: "",
    price: "770",
    image: "https://idzuo.com/menuImages/smash/smash-onion-jam.webp",
    cart: "Додајте у корпу",
  },

  //SMASH DRINKS
  {
    id: 150,
    category: "smashdrinks",
    type: "",
    name: "Кока кола 0,33",
    subtitle: "",
    desc: "",
    grams: "",
    price: "130",
    image: "https://idzuo.com/menuImages/drinks/coca_cola_0.33l.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 151,
    category: "smashdrinks",
    type: "",
    name: "Кока кола зеро",
    subtitle: "",
    desc: "",
    grams: "",
    price: "130",
    image:
      "https://idzuo.com/menuImages/drinks/coca_cola_zero_limenka_0.33l.webp",
    cart: "Додајте у корпу",
  },

  //SMASH SIDES
  {
    id: 152,
    category: "smashsides",
    type: "",
    name: "Помфрит 200г",
    subtitle: "",
    desc: "",
    grams: "",
    price: "200",
    image: "https://idzuo.com/menuImages/smash/pomfrit-50g.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 153,
    category: "smashsides",
    type: "",
    name: "Онион рингс 250г",
    subtitle: "",
    desc: "",
    grams: "",
    price: "290",
    image: "https://idzuo.com/menuImages/smash/onion-rings.webp",
    cart: "Додајте у корпу",
  },
];
